import React from 'react';
import { Row, Col, Input, Label } from 'reactstrap';
import { formatDate } from '../Forms/utils';

const getUserDisplayName = user =>
	user?.full_name ||
	[user?.first_name, user?.last_name].filter(Boolean).join(' ').trim() ||
	user?.name ||
	user?.username ||
	'';

const FiscalizacionSummaryCard = ({ dataFiscalizacion }) => {
	const fecha = dataFiscalizacion?.fecha
		? formatDate(dataFiscalizacion.fecha).toLocaleDateString('es-CL')
		: '-';

	const establecimiento = dataFiscalizacion?.establishment?.name || '-';

	const tipo =
		dataFiscalizacion?.inspection_types?.name ||
		dataFiscalizacion?.tipo ||
		'-';

	const entidades =
		dataFiscalizacion?.inspection_authorities?.length > 0
			? dataFiscalizacion.inspection_authorities
					.map(e => e.name || e.label || '')
					.filter(Boolean)
					.join(', ')
			: '-';

	const responsable = getUserDisplayName(dataFiscalizacion?.person) || '-';

	return (
		<Row>
			<Col md={6}>
				<div className='mb-3'>
					<Label className='form-label'>Fecha</Label>
					<Input type='text' value={fecha} disabled readOnly />
				</div>
				<div className='mb-0'>
					<Label className='form-label'>Establecimiento</Label>
					<Input type='text' value={establecimiento} disabled readOnly />
				</div>
			</Col>
			<Col md={6}>
				<div className='mb-3'>
					<Label className='form-label'>Tipo</Label>
					<Input type='text' value={tipo} disabled readOnly />
				</div>
				<div className='mb-0'>
					<Label className='form-label'>Entidad(es)</Label>
					<Input type='text' value={entidades} disabled readOnly />
				</div>
			</Col>
			<Col md={12}>
				<div className='mt-3 mb-0'>
					<Label className='form-label'>Responsable</Label>
					<Input type='text' value={responsable} disabled readOnly />
				</div>
			</Col>
		</Row>
	);
};

export default FiscalizacionSummaryCard;
